import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon/Icon';
import Text from '/component/base/Text';
import {IncentiveTrip} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './Requirements.style';
import {SupportPathProps} from './Requirements.types';

export const SupportPath = ({
  iconColor = '#000',
  supportPathCount = {
    currentCount: 0,
    targetCount: 0,
  },
}: SupportPathProps) => {
  const {tt} = useTranslation('requirements.supportPathText');
  const {currentCount = 0, targetCount = 0} = supportPathCount;
  const isQualified = currentCount >= targetCount;

  return (
    <View
      style={styles.progressBarContainer}
      {...testProperties(IncentiveTrip.itSupportPath)}>
      <Icon
        name={isQualified ? 'circle-checkmark-filled' : 'circle'}
        style={{
          ...styles.circleCheckMarkIcon,
          color: iconColor,
          ...(isQualified
            ? styles.circleCheckedFilledFont
            : styles.circleUnFilledFont),
        }}
        testID={`${IncentiveTrip.itSupportPathGoal}${
          isQualified ? 'checked' : 'unchecked'
        }`}
      />

      {tt('supportPathDescription', () => (
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="caption"
          style={styles.supportPathDescription}
          {...testProperties(IncentiveTrip.itSupportPathDescription)}>
          At least one Coach in your organization on path 1, path 2, or path 3
          qualified for the trip
        </Text>
      ))}
    </View>
  );
};
